























import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { UpdateBanner } from '@/api'
import { Message } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import { VImageUpload } from '@/components/upload'
import constant from '@/utils/constant'

@Component({
  components: {
    VImageUpload,
  },
})
export default class UpdateBannerDialog extends Vue {
  private show = false
  private data: any = {
    picUrl: '',
    jumpPage: 0,
  }
  private jumpPage = constant.BannerJumpPage
  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    bannerName: [this.requiredRule],
  }


  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.show = false
    this.data = {
      picUrl: '',
      jumpPage: 0,
    }
  }
  @Emit('refresh')
  private refresh() {
    return {}
  }
  public open(param: any) {
    this.show = true
    this.data = {...param}
  }

  public async save() {
    const f = this.$refs.form as ElForm
    f.validate(async (success: boolean) => {
      if (!success) {
        return
      }
      const banner = {
        ...this.data,
      }

      await UpdateBanner({
        banner
      })
      this.refresh()
      Message.success('保存')
      this.close()
    })
  }
}
